import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Subject } from 'rxjs';
import { LoaderService } from 'src/app/services/loader.service';
import { tap } from 'rxjs/operators';

@Component({
    selector: 'app-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LoaderComponent {
  color = 'primary';
  mode = 'indeterminate';
  value = 50;

  shouldShowChanged$: Subject<boolean> = this.loaderService.showStateChanged$;

  constructor(private loaderService: LoaderService) {}
}
